/// <reference path="../types/index.d.ts" />

import '../client_forms/denverbotanic/style.css';
import FormStructure from './denverbotanic/form_structure';

export default FormStructure;